// import * as React from "react";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import { useState } from "react";

// export default function PaginationButtons(props: any) {
//   const {
//     handleChange,
//     pageCount,
//     pageNumber,
//     handlePerPage,
//     perPage,
//     enableAll,
//     hideLimit = false,
//   } = props;

//   const [jumpPage, setJumpPage] = useState<number | string>("");

//   const setChange = (event: React.ChangeEvent<unknown>, value: number) => {
//     handleChange(value);
//   };

//   const handleJump = () => {
//     let page = Number(jumpPage);

//     if (page >= 1 && page <= Math.ceil(pageCount / perPage)) {
//       handleChange(page);
//     }

//     setJumpPage("");
//   };

//   return (
//     <div className="relative w-full p-2 mt-0 flex-shrink-0">
//       <div className="bg-[#EFEEED] flex flex-row items-center justify-between flex-wrap xl:flex-nowrap w-full min-h-[60px] p-2 sm:p-3 gap-3 rounded-md">
//         {/* Left Section */}
//         <div className="flex items-center text-sm sm:text-base gap-1 break-words whitespace-nowrap">
//           <span className="hidden lg:block">Showing</span>

//           <span>{(pageNumber - 1) * perPage + 1}</span>

//           <span>to</span>

//           <span>
//             {pageCount < pageNumber * perPage
//               ? pageCount
//               : pageNumber * perPage}
//           </span>

//           <span>of</span>

//           <span>{pageCount}</span>

//           <span className="hidden lg:block ml-1">entries</span>
//         </div>

//         {/* Right Section */}
//         <div className="flex flex-wrap items-center justify-start sm:justify-end gap-2 sm:gap-3 w-full sm:w-auto sm:ml-auto">
//           {/* Per Page */}
//           <div className="flex items-center gap-2">
//             <div className="hidden lg:block text-sm whitespace-nowrap">
//               Records per page
//             </div>

//             <select
//               className="border border-[#595754] rounded-md px-3 py-1 bg-white text-sm sm:text-base min-w-[90px]"
//               value={perPage}
//               onChange={(e) => handlePerPage(e.target.value)}
//               name="rowsPerPage"
//               id="rowsPerPage"
//             >
//               {enableAll && <option value={pageCount}>All</option>}

//               {!hideLimit && (
//                 <>
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                   <option value={50}>50</option>
//                   <option value={100}>100</option>
//                   <option value={200}>200</option>
//                   <option value={500}>500</option>
//                   <option value={1000}>1000</option>
//                 </>
//               )}
//             </select>
//           </div>

//           {/* Pagination */}
//           <div className="overflow-x-auto max-w-full scrollbar-thin">
//             <Stack
//               spacing={1}
//               direction="row"
//               alignItems="center"
//               className="min-w-max"
//             >
//               <Pagination
//                 count={Math.ceil(pageCount / perPage)}
//                 showFirstButton
//                 showLastButton
//                 page={pageNumber}
//                 onChange={setChange}
//                 siblingCount={1}
//                 boundaryCount={1}
//               />
//             </Stack>
//           </div>

//           {/* Jump to Page */}
//           <div className="flex items-center gap-2">
//             <input
//               type="text"
//               inputMode="numeric"
//               pattern="[0-9]*"
//               value={jumpPage}
//               onChange={(e) => {
//                 const value = e.target.value;

//                 const maxPage = Math.ceil(pageCount / perPage);

//                 // Allow only digits
//                 if (/^\d*$/.test(value)) {
//                   if (value === "") {
//                     setJumpPage("");
//                   } else {
//                     const numberValue = Number(value);

//                     if (numberValue >= 1 && numberValue <= maxPage) {
//                       setJumpPage(numberValue);
//                     } else if (numberValue < 1) {
//                       setJumpPage(1);
//                     } else if (numberValue > maxPage) {
//                       setJumpPage(maxPage);
//                     }
//                   }
//                 }
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") handleJump();

//                 // Prevent invalid chars
//                 if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
//                   e.preventDefault();
//                 }
//               }}
//               placeholder="Jump to"
//               className="border border-[#595754] rounded-md px-2 py-1 w-[90px] text-sm sm:text-base bg-white hidden lg:block"
//             />

//             <button
//               onClick={handleJump}
//               className="bg-primary text-white px-3 py-1 rounded-md text-sm sm:text-base whitespace-nowrap hidden lg:block"
//             >
//               Go
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import * as React from "react";
import Pagination from "@mui/material/Pagination";
import { useEffect, useState } from "react";

export default function PaginationButtons(props: any) {
  const {
    handleChange,
    pageCount,
    pageNumber,
    handlePerPage,
    perPage,
    enableAll,
    hideLimit = false,
  } = props;

  const [jumpPage, setJumpPage] = useState<number | string>("");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resizeHandler = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  const totalPages = Math.ceil(pageCount / perPage);

  const isMobile = screenWidth < 640;

  const setChange = (event: React.ChangeEvent<unknown>, value: number) => {
    handleChange(value);
  };

  const handleJump = () => {
    const page = Number(jumpPage);

    if (page >= 1 && page <= totalPages) {
      handleChange(page);
    }

    setJumpPage("");
  };

  return (
    <div className="w-full p-2">
      <div
        className="
          bg-[#EFEEED]
          rounded-md
          p-3
          flex
          flex-col
          xl:flex-row
          xl:items-center
          gap-4
          w-full
        "
      >
        {/* Left Section */}
        <div
          className="
            flex
            items-center
            gap-1
            whitespace-nowrap
            text-sm
            sm:text-base
            flex-shrink-0
          "
        >
          <span className="hidden lg:block">Showing</span>

          <span>{(pageNumber - 1) * perPage + 1}</span>

          <span>to</span>

          <span>{Math.min(pageNumber * perPage, pageCount)}</span>

          <span>of</span>

          <span>{pageCount}</span>

          <span className="hidden lg:block">entries</span>
        </div>

        {/* Right Section */}
        <div
          className="
            flex
            items-center
            gap-3
            flex-1
            min-w-0
            xl:justify-end
          "
        >
          {/* Records Per Page */}
          <div
            className="
              flex
              items-center
              gap-2
              flex-shrink-0
            "
          >
            <span className="hidden lg:block text-sm whitespace-nowrap">
              Records per page
            </span>

            <select
              className="
                border
                border-[#595754]
                rounded-md
                px-3
                py-1
                bg-white
                text-sm
                sm:text-base
                min-w-[85px]
                outline-none
              "
              value={perPage}
              onChange={(e) => handlePerPage(e.target.value)}
              name="rowsPerPage"
              id="rowsPerPage"
            >
              {enableAll && <option value={pageCount}>All</option>}

              {!hideLimit && (
                <>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={500}>500</option>
                  <option value={1000}>1000</option>
                </>
              )}
            </select>
          </div>

          {/* Pagination */}
          <div
            className="
              flex-1
              min-w-0
              overflow-x-auto
              overflow-y-hidden
              scrollbar-hide
            "
          >
            <div className="w-max">
              <Pagination
                count={totalPages}
                page={pageNumber}
                onChange={setChange}
                showFirstButton={!isMobile}
                showLastButton={!isMobile}
                siblingCount={isMobile ? 0 : 1}
                boundaryCount={1}
                size={isMobile ? "small" : "medium"}
                sx={{
                  "& ul": {
                    flexWrap: "nowrap",
                  },

                  "& .MuiPaginationItem-root": {
                    flexShrink: 0,
                  },
                }}
              />
            </div>
          </div>

          {/* Jump To Page */}
          <div
            className="
              flex
              items-center
              gap-2
              flex-shrink-0
            "
          >
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={jumpPage}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*$/.test(value)) {
                  if (value === "") {
                    setJumpPage("");
                  } else {
                    let numberValue = Number(value);

                    if (numberValue < 1) {
                      numberValue = 1;
                    }

                    if (numberValue > totalPages) {
                      numberValue = totalPages;
                    }

                    setJumpPage(numberValue);
                  }
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleJump();
                }

                if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              placeholder="Jump to"
              className="
                border
                border-[#595754]
                rounded-md
                px-2
                py-1
                bg-white
                text-sm
                outline-none

                w-[70px]
                sm:w-[80px]
              "
            />

            <button
              onClick={handleJump}
              className="
                bg-primary
                text-white
                px-2
                sm:px-3
                py-1
                rounded-md
                text-sm
                whitespace-nowrap
              "
            >
              Go
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
